import React from 'react';
import { useAppContext } from '../../context/AppContext';
import { MapPin, Clock, Users, ArrowRight, Briefcase } from 'lucide-react';

const OpenPositionsPage = () => {
  const { setContactFormOpen } = useAppContext();
  
  return (
    <div className="flex flex-col">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-green-900 via-blue-800 to-teal-700 text-white py-20 md:py-32">
        <div className="container mx-auto px-4 relative">
          <div className="max-w-4xl">
            <div className="mb-6">
              {/* <span className="inline-block bg-yellow-400 text-black px-4 py-2 rounded-md text-sm font-bold uppercase tracking-wide">
                Open Positions
              </span> */}
            </div>
            <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
              Join Our Growing Team
            </h1>
            <p className="text-xl md:text-2xl mb-8 leading-relaxed opacity-90">
              We're looking for talented individuals who are passionate about technology and want to make a difference in the world of software engineering.
            </p>
            {/* <p className="text-lg mb-12 leading-relaxed opacity-80">
              Currently, we're focusing on our internship program, but we're always open to connecting with exceptional talent.
            </p> */}
          </div>
        </div>
      </section>

      {/* Current Openings Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Current Openings</h2>
            {/* <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              While we're in the early stages of our journey, we're building our team strategically and looking for the right people to join us.
            </p> */}
          </div>
          
          <div className="max-w-4xl mx-auto">
            {/* Internship Position */}
            <div className="bg-white rounded-xl shadow-lg border-l-4 border-blue-600 p-8 mb-8">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between">
                <div className="flex-1">
                  <div className="flex items-center mb-4">
                    <div className="bg-blue-100 p-2 rounded-lg mr-4">
                      <Briefcase className="text-blue-600" size={24} />
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-gray-800">Software Development Internship</h3>
                      <p className="text-blue-600 font-medium">Coming Soon</p>
                    </div>
                  </div>
                  
                  <div className="grid md:grid-cols-3 gap-4 mb-6">
                    <div className="flex items-center text-gray-600">
                      <MapPin size={16} className="mr-2" />
                      <span>India</span>
                    </div>
                    <div className="flex items-center text-gray-600">
                      <Clock size={16} className="mr-2" />
                      <span>6 months</span>
                    </div>
                    <div className="flex items-center text-gray-600">
                      <Users size={16} className="mr-2" />
                      <span>Full-time</span>
                    </div>
                  </div>
                  
                  <p className="text-gray-700 mb-6">
                    Join our upcoming internship program to gain hands-on experience in software development, 
                    working alongside experienced engineers on real-world projects. This is a great opportunity 
                    to learn, grow, and potentially transition into a full-time role.
                  </p>
                  
                  <div className="mb-6">
                    <h4 className="font-semibold mb-3">What you'll learn:</h4>
                    <ul className="text-gray-700 space-y-2">
                      <li className="flex items-start">
                        <span className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                        Modern software development practices and methodologies
                      </li>
                      <li className="flex items-start">
                        <span className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                        Working with international clients and global teams
                      </li>
                      <li className="flex items-start">
                        <span className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                        Latest technologies and industry best practices
                      </li>
                      <li className="flex items-start">
                        <span className="w-2 h-2 bg-blue-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                        Professional development and career guidance
                      </li>
                    </ul>
                  </div>
                </div>
                
                <div className="lg:ml-8 lg:flex-shrink-0">
                  <button 
                    onClick={() => setContactFormOpen(true)}
                    className="w-full lg:w-auto bg-blue-600 text-white font-bold py-3 px-6 rounded-md hover:bg-blue-700 transition-colors inline-flex items-center justify-center group"
                  >
                    Express Interest
                    {/* <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" /> */}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Future Opportunities Section */}
      {/* <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">Future Opportunities</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              As we grow, we'll be looking for talented professionals in various roles. Here's what we're planning for:
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="bg-blue-100 p-3 rounded-lg w-12 h-12 mb-4 flex items-center justify-center">
                <span className="text-blue-600 font-bold">💻</span>
              </div>
              <h3 className="text-xl font-bold mb-3">Software Engineers</h3>
              <p className="text-gray-700">Full-stack developers, frontend specialists, and backend engineers</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="bg-green-100 p-3 rounded-lg w-12 h-12 mb-4 flex items-center justify-center">
                <span className="text-green-600 font-bold">⚙️</span>
              </div>
              <h3 className="text-xl font-bold mb-3">DevOps Engineers</h3>
              <p className="text-gray-700">Cloud infrastructure, CI/CD, and automation specialists</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="bg-purple-100 p-3 rounded-lg w-12 h-12 mb-4 flex items-center justify-center">
                <span className="text-purple-600 font-bold">🔍</span>
              </div>
              <h3 className="text-xl font-bold mb-3">QA Engineers</h3>
              <p className="text-gray-700">Manual and automation testing, quality assurance experts</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="bg-orange-100 p-3 rounded-lg w-12 h-12 mb-4 flex items-center justify-center">
                <span className="text-orange-600 font-bold">📐</span>
              </div>
              <h3 className="text-xl font-bold mb-3">System Architects</h3>
              <p className="text-gray-700">Technical architects and solution design experts</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="bg-red-100 p-3 rounded-lg w-12 h-12 mb-4 flex items-center justify-center">
                <span className="text-red-600 font-bold">👥</span>
              </div>
              <h3 className="text-xl font-bold mb-3">Project Managers</h3>
              <p className="text-gray-700">Technical project managers and delivery leads</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="bg-teal-100 p-3 rounded-lg w-12 h-12 mb-4 flex items-center justify-center">
                <span className="text-teal-600 font-bold">🎯</span>
              </div>
              <h3 className="text-xl font-bold mb-3">Product Specialists</h3>
              <p className="text-gray-700">Product managers and business analysts</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Application Process Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">How to Apply</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              We'd love to hear from you and keep your profile for future opportunities.
            </p>
          </div>
          
          <div className="max-w-3xl mx-auto">
            <div className="grid md:grid-cols-3 gap-8 mb-12">
              <div className="text-center">
                <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-blue-600">1</span>
                </div>
                <h3 className="text-xl font-bold mb-3">Submit Your Interest</h3>
                <p className="text-gray-700">Click the "Get in Touch" button and tell us about yourself and your interests.</p>
              </div>
              
              <div className="text-center">
                <div className="bg-green-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-green-600">2</span>
                </div>
                <h3 className="text-xl font-bold mb-3">Initial Conversation</h3>
                <p className="text-gray-700">We'll have a friendly chat to understand your background and career goals.</p>
              </div>
              
              <div className="text-center">
                <div className="bg-purple-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-purple-600">3</span>
                </div>
                <h3 className="text-xl font-bold mb-3">Stay Connected</h3>
                <p className="text-gray-700">We'll keep you updated about relevant opportunities as we grow our team.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative bg-gradient-to-r from-green-900 via-blue-800 to-teal-700 text-white py-20 md:py-32">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">Don't See the Perfect Role?</h2>
          <p className="text-xl mb-8 opacity-90 max-w-2xl mx-auto">
            We're always looking for talented individuals to join our team. Submit your resume and we'll get in touch when a suitable opportunity arises.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
              onClick={() => setContactFormOpen(true)}
              className="bg-yellow-400 text-black font-bold py-4 px-8 rounded-md hover:bg-yellow-300 transition-colors inline-flex items-center justify-center group"
            >
              GET IN TOUCH
              {/* <ArrowRight size={20} className="ml-2 group-hover:translate-x-1 transition-transform" /> */}
            </button>
            {/* <button className="border-2 border-white text-white font-bold py-4 px-8 rounded-md hover:bg-white hover:text-green-900 transition-colors">
              Learn About Our Culture
            </button> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default OpenPositionsPage;